import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { TestimoniesDetails } from './gadgets';
import{FaQuoteRight}from 'react-icons/fa'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Testimonies=()=> {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
                      {TestimoniesDetails.map((img, index) => {
                          return (
        <Grid item xs={12} md={6}  key={index}>
                  <Item>
                              <Card  sx={{ maxWidth: 345,textAlign:'center' ,margin: 'auto',}}>
      <CardMedia
        sx={{ height: 250 }}
        image={img.image}
      title="kenneth art"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
<FaQuoteRight/>
        </Typography>
        <Typography sx={{fontSize:'1rem',textTransform:'capitalize'}} variant="body2" color="text.secondary">
         {img.descrip}
        </Typography>
      </CardContent>
      
    </Card>
          </Item>
        </Grid>
                          )
                      })}

      </Grid>
    </Box>
  );
}

export default Testimonies;